import { StyledGrid } from "@hcl-commerce-store-sdk/react-component";
import styled from "styled-components";
//spot onboard-logo-footer
import SpotTemplate from "../../custom/spot/SpotTemplate";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";

const FooterLogoContainer = styled((props: any) => <StyledGrid {...props} />)`
  ${({ theme }) => `
.logo_onboard_footer {
    height: 27px;
    width: 169px;
  }

  .logo_onboard_footer_desktop {
    height: 39px;
    width: 216px;
  }
`}
`;

export const FooterLogo = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <FooterLogoContainer>
      <div className={isMobile ? "logo_onboard_footer" : "logo_onboard_footer_desktop"}>
        <SpotTemplate espotName={"LogoFooter"} />
      </div>
    </FooterLogoContainer>
  );
};
